import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { auth } from '../../firebase';

import '../../global.css';
import './PasswordForget.css';

const PasswordForgetPage = () =>
    <div>
        <PasswordForgetForm />
    </div>;

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    email: '',
    error: null,
};

class PasswordForgetForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = (event) => {
        const { email } = this.state;

        auth.doPasswordReset(email)
            .then(() => {
                this.setState(() => ({ ...INITIAL_STATE }));
            })
            .catch(error => {
                this.setState(byPropKey('error', error));
            });

        event.preventDefault();
    };

    render() {
        const {
            email,
            error,
        } = this.state;

        const isInvalid = email === '';

        return (
            <div className="main">
                <div className="mostly-opaque-white">

                <form  className="form-signin" onSubmit={this.onSubmit}>
                <h2 className="big-bottom-margin">
                    Reset Password
                </h2>

                <input
                    type="email"
                    value={this.state.email}
                    onChange={event => this.setState(byPropKey('email', event.target.value))}
                    placeholder="Email Address"
                    className="form-control"
                />
                { error && <p className="text-danger">{error.message}</p> }

                <button disabled={isInvalid} className="btn btn-lg btn-primary btn-block big-top-margin" type="submit">
                    Reset My Password
                </button>

            </form>
                </div>
            </div>
        );
    }
}

const PasswordForgetLink = () =>
    <p>
        <Link className="text-primary" to="/pw-forget">Forgot Password?</Link>
    </p>;

export default PasswordForgetPage;

export {
    PasswordForgetForm,
    PasswordForgetLink,
};


// WEBPACK FOOTER //
// ./src/components/auth/PasswordForget.js